// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NyDNy","largestCol":"styles_largestCol__1_gsS","smallestCol":"styles_smallestCol__23s2o"};